<ng-container *transloco="let t">
    <div fxLayout="row" fxFlexFill>
        <div fxLayout="row" fxFlex (window:resize)="onResize()">
            <div class="right-panel" fxFlex fxLayout="column">
                <div fxFlex class="main-container">
                    <div class="map" #sitelistmap></div>
                </div>
            </div>
        </div>

        <div class="org-container" fxFlex="25%" *ngIf="selectedRegionId">
            <h3 class="org-header" fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
                <mat-icon>business</mat-icon>
                <span>{{ selectedRegionName }} - {{ t('organizations') }}</span>
            </h3>

            <div *ngIf="isLoadingOrgs" class="org-loader" fxLayout="column" fxLayoutAlign="center center">
                <mat-progress-spinner mode="indeterminate" diameter="50" color="primary"></mat-progress-spinner>
                <p>Loading organizations...</p>
            </div>

            <div fxLayout="column" fxLayoutGap="16px" fxLayoutWrap
                *ngIf="!isLoadingOrgs && filteredOrganisations.length > 0" class="org-grid">
                <mat-card *ngFor="let org of filteredOrganisations" class="org-tile" (click)="selectOrg(org.id)">
                    <div fxLayout="column" fxLayoutAlign="center center">
                        <mat-icon>apartment</mat-icon>
                        <mat-card-title>{{ org.organisationName }}</mat-card-title>
                    </div>
                </mat-card>
            </div>

            <div *ngIf="!isLoadingOrgs && filteredOrganisations.length === 0" class="no-orgs" fxLayout="column"
                fxLayoutAlign="center center">
                <mat-icon>info</mat-icon>
                <p>No organizations assigned for this region.</p>
            </div>
        </div>
    </div>
</ng-container>